// extracted by mini-css-extract-plugin
export var button = "bS_m2";
export var button__darkBlue = "bS_m6";
export var button__edgesGrey = "bS_m7";
export var button__edgesRed = "bS_m4";
export var button__loader = "bS_m8";
export var button__red = "bS_m3";
export var button__transparent = "bS_m5";
export var loadingSpinner = "bS_m9";